<template>
  <div class="video-intro" :class="type">
     <div class="video-wrap" @click="playVideo">
      <img src="@/assets/imgs/optimize/video-img.png" alt="close" class="video-bg">
      <img src="@/assets/imgs/optimize/video-play.png" alt="play" class="play-icon" @click="play">
      <div class="mask"></div>
     </div>
     <div class="intro">
      <span v-html="videoIntroText"></span>
     </div>
  </div>
</template>

<script setup>
import { computed, defineEmits } from 'vue'
import { isMobile } from '@/utils'
import { useI18n } from 'vue-i18n'
// import videoIframeMap from './videoIframeMap'

const { /* locale,  */t } = useI18n()
const emit = defineEmits(['playVideo'])
const playVideo = () => {
  emit('playVideo')
}
const type = isMobile ? 'mobile' : 'pc'
const videoIntroText = computed(() => {
  let text = t('payment.videoIntro')
  text = text.replace(/\n\n/g, '\n<br />')
  const texts = text.split('\n')
  return texts.map(text => {
    return `<div>${text}</div>`
  }).join('')
})
// const videoShareIframeText = computed(() => {
//   let key = ''
//   if (['en', 'sg', 'my', 'ph', 'in'].includes(locale.value)) {
//     key = 'en'
//   } else if (['hk', 'tw'].includes(locale.value)) {
//     key = 'hk'
//   } else if(['vi'].includes(key)) {
//     key = 'vi'
//   } else if(['th'].includes(locale.value)) {
//     key = 'th'
//   } else {
//     key = 'en'
//   }
//   let res = videoIframeMap[key] || videoIframeMap.en
//   if (res) {
//     res = res.replace(/height="[0-9]+"/, 'height="100%"')
//     res = res.replace(/width="[0-9]+"/, 'width="100%"')
//   }
//   return res
// })
</script>

<style lang="less" scoped src="./mobile_style.less"></style>
<style lang="less" scoped src="./pc_style.less"></style>